import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { getErrorText } from 'utils/getErrorText';
import { DatePickerComponent } from 'components/Inputs/DatePickerComponents/DatePickerComponent';
import { ErrorIcon } from 'components/Core/ErorrIcon/ErrorIcon';
import { ReactComponent as StarIcon } from 'assets/star_required_icon.svg';
import { IDatePickerRowProps } from './types';
import styles from './datePickerRow.module.scss';

export const DatePickerRow: FC<IDatePickerRowProps> = ({
  startName,
  endName,
  startPlaceholder,
  endPlaceholder,
  startLabel,
  endLabel,
  requiredStart = false,
  requiredEnd = false,
  noMaxDateStart = false,
  noMaxDateEnd = false,
  isTwoRows = false,
  stylesProp,
  isDisabledStart = false,
  isDisabledEnd = false,
}) => {
  const formContext = useFormContext();
  const { watch, getFieldState } = formContext;
  return (
    <>
      <div className={`${styles.row} ${isTwoRows && styles.twoRows}`}>
        <div className={`${styles.label} ${styles.start}`}>
          {startLabel && <p className={`${styles.subtitle}`}>{startLabel}</p>}
          {requiredStart ? <StarIcon className={styles.requiredIcon} /> : null}
        </div>
        <DatePickerComponent
          name={startName}
          placeholder={startPlaceholder}
          required={requiredStart}
          isClearable
          noMaxDate={!watch(endName) && noMaxDateStart}
          maxDate={watch(endName) ? new Date(watch(endName)) : undefined}
          stylesProp={stylesProp?.styleProps}
          buttonStyleProp={stylesProp?.buttonStyleProp}
          disabled={isDisabledStart}
          showRequiredIcon={!startLabel}
        />
        <div className={`${styles.label} ${styles.end}`}>
          {endLabel && <p className={`${styles.subtitle}`}>{endLabel}</p>}
          {requiredEnd ? <StarIcon className={styles.requiredIcon} /> : null}
        </div>
        <DatePickerComponent
          name={endName}
          placeholder={endPlaceholder}
          required={requiredEnd}
          minDate={new Date(watch(startName))}
          isClearable
          disabled={!watch(startName) || isDisabledEnd}
          noMaxDate={noMaxDateEnd}
          stylesProp={stylesProp?.styleProps}
          buttonStyleProp={stylesProp?.buttonStyleProp}
          showRequiredIcon={!endLabel}
        />
        {((getFieldState(startName).error && !watch(startName)) || getFieldState(endName).error) && (
          <ErrorIcon
            name={`${startLabel}_datepicker`}
            message={getErrorText(
              ((getFieldState(startName).error || getFieldState(endName).error)?.type as string) || '',
              {
                errorText: 'Please fill all the required fields',
              }
            )}
          />
        )}
      </div>
    </>
  );
};
